import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { Button } from '../../components';

import {
  PanelMobile,
  MobileButton,
  MobileTotal,
  PanelContainer,
  PanelImageContainer,
  PanelPaymentInfo,
  PanelPaymentItem,
  PanelAccordion,
  PanelButton,
  PanelMessage,
  PerkBadge,
  PanelPaymentDelimiter,
  PanelPaymentHeading,
} from './styles';

const PaymentInfoContainer = ({ highlight, description, price, subtotal, total, credit, formInstance }) => {
  const [isDisabled] = useState(true);

  const [isOpen, openPolicies] = useState(false);

  return (
    <PanelPaymentInfo>
      <PanelMobile>
        <MobileTotal>
          <h3>Total today</h3>
          <p>${total / 100}</p>
        </MobileTotal>
        <MobileButton>
          <Button
            htmlType="button"
            theme="primary"
            onClick={formInstance && formInstance.submitForm}
            disabled={isDisabled}
          >
            Purchase
          </Button>
        </MobileButton>
      </PanelMobile>
      <PanelPaymentHeading>Confirm and pay</PanelPaymentHeading>
      <PanelPaymentItem>
        <span>
          <span className="semibold">Monthly Subscription</span>
          <span className="subtitle">{highlight}</span>
        </span>
        <span className="row semibold medium blue">
          ${price / 100}
          <span className="small">/month</span>
        </span>
      </PanelPaymentItem>
      <PanelPaymentDelimiter />
      <PanelAccordion>
        <PanelButton type="button" isOpen={isOpen} onClick={() => openPolicies(!isOpen)}>Plan Policies</PanelButton>
        {isOpen && (
          <PanelMessage>
            <span dangerouslySetInnerHTML={{ __html: description }} />
          </PanelMessage>
        )}
      </PanelAccordion>
      <PanelPaymentDelimiter />
      <PanelPaymentItem>
        <span className="semibold">Plan starts</span>
        <span>On {moment().format('MMM DD, YYYY')}</span>
      </PanelPaymentItem>
      <PanelPaymentDelimiter />
      <PanelPaymentItem>
        <PerkBadge>Special Perks</PerkBadge>
        <span className="semibold small">10% OFF additional passes for friends & family, limit 2 uses per month</span>
      </PanelPaymentItem>
      <PanelPaymentDelimiter />
      <PanelPaymentItem>
        <span>Subtotal</span>
        <span className="medium">${subtotal / 100}</span>
      </PanelPaymentItem>
      {credit && (
        <PanelPaymentItem>
          <span>Credit</span>
          <span className="medium">-${credit / 100}</span>
        </PanelPaymentItem>
      )}
      <PanelPaymentItem>
        <span className="bold">Total today</span>
        <span className="bold large">${total / 100}</span>
      </PanelPaymentItem>
    </PanelPaymentInfo>
  );
};

const PaymentImage = ({ image }) => (
  <PanelImageContainer>
    <img src={`${process.env.CDN_URL}${image}`} alt="Buy your pass" />
  </PanelImageContainer>
);

PaymentImage.propTypes = {
  image: PropTypes.string,
};

PaymentInfoContainer.propTypes = {
  highlight: PropTypes.string,
  description: PropTypes.string,
  credit: PropTypes.number,
  price: PropTypes.number,
  subtotal: PropTypes.number,
  total: PropTypes.number,
  formInstance: PropTypes.instanceOf(Object),
};

class PassPanel extends Component {
  static PanelContainer = PanelContainer;

  static PanelImageContainer = PaymentImage;

  static PaymentInfo = PaymentInfoContainer;

  render() {
    return null;
  }
}

export default PassPanel;
